import Heading from "shared/ui/typography/Heading";
import {
  USPListItemType,
  acousticPanelUsps,
  glassNavulUSP,
  glassNewSetUSP,
  glassUsps,
  paintUsps,
  voucherUsps,
} from "shared/utils/usps";
import { USPHeaderList } from "widgets/configurator/usp-header-list";
import { AcousticPanelUSPList } from "./components/AcousticPanelUSPList";

const glasCleanerSetCodes = [
  "zoschoonglasstart",
  "zoschoonallesstart",
  "zoschoonglasnavul",
  "zoschoonglasdoekxl",
  "zoschoonallesdoek",
  "zoschoonglasdoek",
];
interface Props {
  title: string;
  code?: string;
  description: string;
  selectedProductCode?: string;
}

const uspTypeMap: { [key: string]: USPListItemType | undefined } = {
  gereedschap: undefined,
  glasreiniger: glassUsps,
  verfset: paintUsps,
  cadeaukaart: voucherUsps,
  default: acousticPanelUsps,
};

const selectUSPType = (
  code: string | undefined,
  selectedProductCode?: string,
) => {
  if (code) {
    // Handling new glass cleaner set codes
    if (code === "glasreininger") {
      if (selectedProductCode === "zoschoonallesnavul") {
        return glassNavulUSP;
      } else if (
        selectedProductCode &&
        glasCleanerSetCodes.includes(selectedProductCode)
      ) {
        return glassNewSetUSP;
      }
    }

    // Handle products besides glasses
    return uspTypeMap[code] || uspTypeMap.default;
  }
};

const selectUSPComponent = (code: string | undefined, uspList: any) => {
  if (
    code === "gereedschap" ||
    code === "glasreiniger" ||
    code === "verfset" ||
    code === "cadeaukaart"
  ) {
    return <USPHeaderList uspList={uspList} />;
  } else {
    return <AcousticPanelUSPList uspList={uspList} />;
  }
};

const StandardProductOptionsHeader = ({
  title,
  code,
  description,
  selectedProductCode,
}: Props) => {
  const uspList = selectUSPType(code, selectedProductCode);
  const uspComponent = selectUSPComponent(code, uspList);

  const lineBrokenDescription = description.split(".", 2);

  return (
    <>
      <header className="gg-border-b gg-border-dark-blue-100 gg-px-4 gg-pb-5 gg-pt-4 sm:gg-px-7 lg:gg-pb-6 lg:gg-pt-6">
        <Heading
          headingLevel="h2"
          className="gg-font-bold gg-leading-6 gg-text-slate-800 md:gg-leading-8 lg:gg-text-2xl"
        >
          {title}
        </Heading>
        {description && (
          <h3 className="gg-mt-2.5 gg-text-sm gg-leading-6 gg-text-slate-800">
            <span> {lineBrokenDescription[0]}</span>
            <p>{lineBrokenDescription[1]}</p>
          </h3>
        )}
        {uspList && uspComponent}
      </header>
    </>
  );
};
export default StandardProductOptionsHeader;
